import React from 'react';
import { BookOpen, FileText, MessageSquare, Newspaper } from 'lucide-react';

const resources = [
  { title: 'Career Guide', icon: BookOpen, url: 'https://canxglobal.com/career-guide/' },
  { title: 'Resume Guide', icon: FileText, url: 'https://canxglobal.com/career-guide/resume-guide/' },
  { title: 'Interview Guide', icon: MessageSquare, url: 'https://canxglobal.com/career-guide/interview-guide/' },
  { title: 'Blog', icon: Newspaper, url: 'https://canxglobal.com/blog/' }
];

export const ResourceButtons = () => {
  return (
    <section className="py-20 md:py-24 px-4 md:px-6 bg-white" data-testid="resources-section">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold">
            <span className="text-zinc-900">Everything You Need to </span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gradient-start to-brand-gradient-end">Succeed</span>
            <span className="text-zinc-900"> in Your Career</span>
          </h2>
        </div>
        
        {/* Resource Cards - Centered */}
        <div className="flex flex-wrap justify-center gap-5 md:gap-8">
          {resources.map((resource, index) => {
            const IconComponent = resource.icon;
            return (
              <button
                key={index}
                onClick={() => window.open(resource.url, '_blank')}
                className="group bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-6 md:p-8 border border-cyan-100 hover:shadow-xl hover:border-brand-blue hover:-translate-y-1 transition-all duration-300 flex flex-col items-center text-center w-[140px] sm:w-[160px] md:w-[180px]"
                data-testid={`resource-${resource.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {/* Icon */}
                <div className="w-14 h-14 md:w-16 md:h-16 bg-brand-blue rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <IconComponent className="w-7 h-7 md:w-8 md:h-8 text-white" strokeWidth={2} />
                </div>
                
                {/* Title */}
                <span className="font-semibold text-zinc-800 text-sm md:text-base group-hover:text-brand-blue transition-colors">
                  {resource.title}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ResourceButtons;
